import Assassin from "assets/images/class_icons/assassin_icon.png";
import Barbarian from "assets/images/class_icons/barbarian_icon.png";
import Ranger from "assets/images/class_icons/ranger_icon.png";
import PriestofMitra from "assets/images/class_icons/priestofmitra_icon.png";
import TempestofSet from "assets/images/class_icons/tempestofset_icon.png";
import BearShaman from "assets/images/class_icons/bearshaman_icon.png";
import Demonologist from "assets/images/class_icons/demonologist_icon.png";
import Necromancer from "assets/images/class_icons/necromancer_icon.png";
import HeraldofXotli from "assets/images/class_icons/heraldofxotli_icon.png";
import Guardian from "assets/images/class_icons/guardian_icon.png";
import Conqueror from "assets/images/class_icons/conqueror_icon.png";
import DarkTemplar from "assets/images/class_icons/darktemplar_icon.png";
import AssassinWhite from "assets/images/class_icons/assassin_white_icon.png";
import BarbarianWhite from "assets/images/class_icons/barbarian_white_icon.png";
import RangerWhite from "assets/images/class_icons/ranger_white_icon.png";
import PriestofMitraWhite from "assets/images/class_icons/priestofmitra_white_icon.png";
import TempestofSetWhite from "assets/images/class_icons/tempestofset_white_icon.png";
import BearShamanWhite from "assets/images/class_icons/bearshaman_white_icon.png";
import DemonologistWhite from "assets/images/class_icons/demonologist_white_icon.png";
import NecromancerWhite from "assets/images/class_icons/necromancer_white_icon.png";
import HeraldofXotliWhite from "assets/images/class_icons/heraldofxotli_white_icon.png";
import GuardianWhite from "assets/images/class_icons/guardian_white_icon.png";
import ConquerorWhite from "assets/images/class_icons/conqueror_white_icon.png";
import DarkTemplarWhite from "assets/images/class_icons/darktemplar_white_icon.png";
import AssassinColor from "assets/images/class_icons/assassin_color.png";
import BarbarianColor from "assets/images/class_icons/barbarian_color.png";
import RangerColor from "assets/images/class_icons/ranger_color.png";
import PriestofMitraColor from "assets/images/class_icons/priestofmitra_color.png";
import TempestofSetColor from "assets/images/class_icons/tempestofset_color.png";
import BearShamanColor from "assets/images/class_icons/bearshaman_color.png";
import DemonologistColor from "assets/images/class_icons/demonologist_color.png";
import NecromancerColor from "assets/images/class_icons/necromancer_color.png";
import HeraldofXotliColor from "assets/images/class_icons/heraldofxotli_color.png";
import GuardianColor from "assets/images/class_icons/guardian_color.png";
import ConquerorColor from "assets/images/class_icons/conqueror_color.png";
import DarkTemplarColor from "assets/images/class_icons/darktemplar_color.png";

import AssassinPortrait from "assets/images/class_portraits/assassin.png";
import BarbarianPortrait from "assets/images/class_portraits/barbarian.png";
import RangerPortrait from "assets/images/class_portraits/ranger.png";
import PriestofMitraPortrait from "assets/images/class_portraits/priestofmitra.png";
import TempestofSetPortrait from "assets/images/class_portraits/tempestofset.png";
import BearShamanPortrait from "assets/images/class_portraits/bearshaman.png";
import DemonologistPortrait from "assets/images/class_portraits/demonologist.png";
import NecromancerPortrait from "assets/images/class_portraits/necromancer.png";
import HeraldofXotliPortrait from "assets/images/class_portraits/heraldofxotli.png";
import GuardianPortrait from "assets/images/class_portraits/guardian.png";
import ConquerorPortrait from "assets/images/class_portraits/conqueror.png";
import DarkTemplarPortrait from "assets/images/class_portraits/darktemplar.png";

import AssassinAction from "assets/images/class_portraits/assassinaction.png";
import BarbarianAction from "assets/images/class_portraits/barbarianaction.png";
import RangerAction from "assets/images/class_portraits/rangeraction.png";
import PriestofMitraAction from "assets/images/class_portraits/priestofmitraaction.png";
import TempestofSetAction from "assets/images/class_portraits/tempestofsetaction.png";
import BearShamanAction from "assets/images/class_portraits/bearshamanaction.png";
import DemonologistAction from "assets/images/class_portraits/demonologistaction.png";
import NecromancerAction from "assets/images/class_portraits/necromanceraction.png";
import HeraldofXotliAction from "assets/images/class_portraits/heraldofxotliaction.png";
import GuardianAction from "assets/images/class_portraits/guardianaction.png";
import ConquerorAction from "assets/images/class_portraits/conqueroraction.png";
import DarkTemplarAction from "assets/images/class_portraits/darktemplaraction.png";

import AssassinHead from "assets/images/class_portraits/assassinhead.png";
import BarbarianHead from "assets/images/class_portraits/barbarianhead.png";
import RangerHead from "assets/images/class_portraits/rangerhead.png";
import PriestofMitraHead from "assets/images/class_portraits/priestofmitrahead.png";
import TempestofSetHead from "assets/images/class_portraits/tempestofsethead.png";
import BearShamanHead from "assets/images/class_portraits/bearshamanhead.png";
import DemonologistHead from "assets/images/class_portraits/demonologisthead.png";
import NecromancerHead from "assets/images/class_portraits/necromancerhead.png";
import HeraldofXotliHead from "assets/images/class_portraits/heraldofxotlihead.png";
import GuardianHead from "assets/images/class_portraits/guardianhead.png";
import ConquerorHead from "assets/images/class_portraits/conquerorhead.png";
import DarkTemplarHead from "assets/images/class_portraits/darktemplarhead.png";

import TempestofSetBg from "assets/images/class_bg/tempestofsetbg.jpg";
import DemonologistBg from "assets/images/class_bg/demonlogistbg.jpg";
import ConquerorBg from "assets/images/class_bg/conquerorbg.jpg";
import BearshamanBg from "assets/images/class_bg/bearshamanbg.jpg";
import HeraldofXotliBg from "assets/images/class_bg/heraldofxotlibg.jpg";
import BarbarianBg  from "assets/images/class_bg/barbarianbg.jpg";
import GuardianBg from "assets/images/class_bg/guardianbg.jpg";
import NecromancerBg from "assets/images/class_bg/necromancerbg.jpg";
import AssassinBg from "assets/images/class_bg/assassinbg.jpg";
import DarkTemplarBg from "assets/images/class_bg/darktemplarbg.jpg";
import PriestofMitraBg from "assets/images/class_bg/priestofmitrabg.jpg";
import RangerBg from "assets/images/class_bg/rangerbg.jpg";

import BlankColor from "assets/images/class_icons/no_select.png";
import RandomColor from "assets/images/class_icons/random.png";

import { AocClasses } from "@pvplevelup/core/dist/interfaces/ICharacter";

class ClassImages {
  getStandardIcon(character_class: string){
    switch(character_class){
      case AocClasses.Assassin:
        return Assassin;
      case AocClasses.Barbarian:
        return Barbarian;
      case AocClasses.Ranger:
        return Ranger;
      case AocClasses.PriestofMitra:
        return PriestofMitra;
      case AocClasses.TempestofSet:
        return TempestofSet;
      case AocClasses.BearShaman:
        return BearShaman;
      case AocClasses.Demonologist:
        return Demonologist;
      case AocClasses.Necromancer:
        return Necromancer;
      case AocClasses.HeraldofXotli:
        return HeraldofXotli;
      case AocClasses.Guardian:
        return Guardian;
      case AocClasses.Conqueror:
        return Conqueror;
      case AocClasses.DarkTemplar:
        return DarkTemplar;
      default:
        return "";
    }
  }

  getWhiteIcon(character_class: string){
    switch(character_class){
      case AocClasses.Assassin:
        return AssassinWhite;
      case AocClasses.Barbarian:
        return BarbarianWhite;
      case AocClasses.Ranger:
        return RangerWhite;
      case AocClasses.PriestofMitra:
        return PriestofMitraWhite;
      case AocClasses.TempestofSet:
        return TempestofSetWhite;
      case AocClasses.BearShaman:
        return BearShamanWhite;
      case AocClasses.Demonologist:
        return DemonologistWhite;
      case AocClasses.Necromancer:
        return NecromancerWhite;
      case AocClasses.HeraldofXotli:
        return HeraldofXotliWhite;
      case AocClasses.Guardian:
        return GuardianWhite;
      case AocClasses.Conqueror:
        return ConquerorWhite;
      case AocClasses.DarkTemplar:
        return DarkTemplarWhite;
      default:
        return "";
    }
  }

  getColorIcon(character_class: string){
    switch(character_class){
      case AocClasses.Assassin:
        return AssassinColor;
      case AocClasses.Barbarian:
        return BarbarianColor;
      case AocClasses.Ranger:
        return RangerColor;
      case AocClasses.PriestofMitra:
        return PriestofMitraColor;
      case AocClasses.TempestofSet:
        return TempestofSetColor;
      case AocClasses.BearShaman:
        return BearShamanColor;
      case AocClasses.Demonologist:
        return DemonologistColor;
      case AocClasses.Necromancer:
        return NecromancerColor;
      case AocClasses.HeraldofXotli:
        return HeraldofXotliColor;
      case AocClasses.Guardian:
        return GuardianColor;
      case AocClasses.Conqueror:
        return ConquerorColor;
      case AocClasses.DarkTemplar:
        return DarkTemplarColor;
      case "Random":
        return RandomColor;
      default:
        return BlankColor;
    }
  }

  getPortrait(character_class: string){
    switch(character_class){
      case AocClasses.Assassin:
        return AssassinPortrait;
      case AocClasses.Barbarian:
        return BarbarianPortrait;
      case AocClasses.Ranger:
        return RangerPortrait;
      case AocClasses.PriestofMitra:
        return PriestofMitraPortrait;
      case AocClasses.TempestofSet:
        return TempestofSetPortrait;
      case AocClasses.BearShaman:
        return BearShamanPortrait;
      case AocClasses.Demonologist:
        return DemonologistPortrait;
      case AocClasses.Necromancer:
        return NecromancerPortrait;
      case AocClasses.HeraldofXotli:
        return HeraldofXotliPortrait;
      case AocClasses.Guardian:
        return GuardianPortrait;
      case AocClasses.Conqueror:
        return ConquerorPortrait;
      case AocClasses.DarkTemplar:
        return DarkTemplarPortrait;
      default:
        return "";
    }
  }

  getActionPortrait(character_class: string){
    switch(character_class){
      case AocClasses.Assassin:
        return AssassinAction;
      case AocClasses.Barbarian:
        return BarbarianAction;
      case AocClasses.Ranger:
        return RangerAction;
      case AocClasses.PriestofMitra:
        return PriestofMitraAction;
      case AocClasses.TempestofSet:
        return TempestofSetAction;
      case AocClasses.BearShaman:
        return BearShamanAction;
      case AocClasses.Demonologist:
        return DemonologistAction;
      case AocClasses.Necromancer:
        return NecromancerAction;
      case AocClasses.HeraldofXotli:
        return HeraldofXotliAction;
      case AocClasses.Guardian:
        return GuardianAction;
      case AocClasses.Conqueror:
        return ConquerorAction;
      case AocClasses.DarkTemplar:
        return DarkTemplarAction;
      default:
        return "";
    }
  }

  getHeadPortrait(character_class: string){
    switch(character_class){
      case AocClasses.Assassin:
        return AssassinHead;
      case AocClasses.Barbarian:
        return BarbarianHead;
      case AocClasses.Ranger:
        return RangerHead;
      case AocClasses.PriestofMitra:
        return PriestofMitraHead;
      case AocClasses.TempestofSet:
        return TempestofSetHead;
      case AocClasses.BearShaman:
        return BearShamanHead;
      case AocClasses.Demonologist:
        return DemonologistHead;
      case AocClasses.Necromancer:
        return NecromancerHead;
      case AocClasses.HeraldofXotli:
        return HeraldofXotliHead;
      case AocClasses.Guardian:
        return GuardianHead;
      case AocClasses.Conqueror:
        return ConquerorHead;
      case AocClasses.DarkTemplar:
        return DarkTemplarHead;
      default:
        return "";
    }
  }

  getBackground(character_class: string){
    switch(character_class){
      case AocClasses.Assassin:
        return AssassinBg;
      case AocClasses.Barbarian:
        return BarbarianBg;
      case AocClasses.Ranger:
        return RangerBg;
      case AocClasses.PriestofMitra:
        return PriestofMitraBg;
      case AocClasses.TempestofSet:
        return TempestofSetBg;
      case AocClasses.BearShaman:
        return BearshamanBg;
      case AocClasses.Demonologist:
        return DemonologistBg;
      case AocClasses.Necromancer:
        return NecromancerBg;
      case AocClasses.HeraldofXotli:
        return HeraldofXotliBg;
      case AocClasses.Guardian:
        return GuardianBg;
      case AocClasses.Conqueror:
        return ConquerorBg;
      case AocClasses.DarkTemplar:
        return DarkTemplarBg;
      default:
        return "";
    }
  }
}

export const classImages = new ClassImages();